import {base64, unbase64} from "./base64";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the 'graphql-relay' directory of this source tree.
 *
 *
 */

/**
 * Takes a type name and an ID specific to that type name, and returns a
 * "global ID" that is unique among all types.
 */
export function toGlobalId(type, id) {
  return base64([type, id].join(":"));
}

/**
 * Takes the "global ID" created by toGlobalID, and returns the type name and ID
 * used to create it.
 */
export function fromGlobalId(globalId) {
  var unbasedGlobalId = unbase64(globalId);
  var delimiterPos = unbasedGlobalId.indexOf(":");
  return {
    type: unbasedGlobalId.substring(0, delimiterPos),
    id: unbasedGlobalId.substring(delimiterPos + 1),
  };
}


export function createLabelFromId(id, prefix) {
  if (id) {
    const num = fromGlobalId(id).id;
    return prefix + num.padStart(12, 0);
  }
  return "Not Available";
}
